import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  className?: string;
};

/** Условное изображение списка диалогов в превью раскладки */
export const SkeletonTable: FC<Props> = ({ className }) => (
  <div className={cn('flex flex-col gap-1 h-full w-full', className)}>
    <Skeleton className={'h-3 w-full'} />
    <Skeleton className={'h-3 w-full'} />
    <Skeleton className={'h-3 w-full'} />
    <Skeleton className={'h-3 w-full'} />
    <Skeleton className={'h-3 w-full'} />
    <Skeleton className={'h-3 w-full'} />
  </div>
);
